import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { Trips } from "@tendercuts/models";

@Injectable()
export class CanHoldService extends BaseGetProvider<Trips> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  // override this
  preProcessResponse(response: any): Array<any> {
    return response.results[0];
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof Trips {
    return Trips;
  }

  get endpoint(): string {
    return this.endpointService.canHold();
  }

  get isCachable(): boolean {
    return false;
  }

  getparams(
    incrementId: string,
  ): {
    increment_id: string;
  } {
    const param: {
      increment_id: string;
    } = {
      increment_id: incrementId,
    };

    return param;
  }
}
